import React, { useState } from 'react';
import { Tabs, Tab, Box } from '@material-ui/core';
import DownloadAllInvoices from './downloadallinvoices';
import RegenerateApplicantInvoice from './regenerateapplicantinvoice';

export default function InvoiceManagementTabs() {
    const [activeTab, setActiveTab] = useState(0);

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    return (
        <Box>
            <Tabs
                value={activeTab}
                onChange={handleTabChange}
                indicatorColor="primary"
                textColor="primary"
                centered
            >
                <Tab label="Regenerate Invoice" />
                <Tab label="Download All Invoices" />
                
            </Tabs>
            <Box mt={2}>
                {activeTab === 0 && <RegenerateApplicantInvoice />}
                {activeTab === 1 && <DownloadAllInvoices />}
                
            </Box>
        </Box>
    );
}
